import { render, staticRenderFns } from "./CouponStocksModal.vue?vue&type=template&id=3280a1bb&scoped=true&"
import script from "./CouponStocksModal.vue?vue&type=script&lang=js&"
export * from "./CouponStocksModal.vue?vue&type=script&lang=js&"
import style0 from "./CouponStocksModal.vue?vue&type=style&index=0&id=3280a1bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3280a1bb",
  null
  
)

export default component.exports